<script setup lang="ts">
defineOptions({
  name: 'Loader',
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['loader', { _mobile: isMobile }]" data-testid="loader">
    <div class="loader__cup-wrapper _left" data-testid="loader-cup-left">
      <div class="loader__cup-top"></div>
      <div class="loader__cup-circle"></div>
      <div class="loader__cup-chain _left" data-testid="loader-cup-chain"></div>
      <div class="loader__cup-chain _right" data-testid="loader-cup-chain"></div>
      <div class="loader__cup"></div>
    </div>
    <div class="loader__cup-wrapper _right" data-testid="loader-cup-right">
      <div class="loader__cup-top"></div>
      <div class="loader__cup-circle"></div>
      <div class="loader__cup-chain _left" data-testid="loader-cup-chain"></div>
      <div class="loader__cup-chain _right" data-testid="loader-cup-chain"></div>
      <div class="loader__cup"></div>
    </div>
    <div class="loader__middle" data-testid="loader-middle">
      <div class="loader__middle-top"></div>
      <div class="loader__middle-bar" data-testid="loader-middle-bar"></div>
      <div class="loader__middle-bottom"></div>
      <div class="loader__middle-base-bottom"></div>
    </div>
    <div class="loader__bottom" data-testid="loader-bottom">
      <div class="loader__bottom-first" data-testid="loader-bottom-first"></div>
      <div class="loader__bottom-second" data-testid="loader-bottom-second"></div>
    </div>
  </div>
</template>

<style lang="less">
.loader {
  position: relative;
  width: 140px;
  height: 65px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  transform: scale(0.5);

  &__cup-top {
    position: absolute;
    top: -6px;
    left: 9px;
    height: 5px;
    background-color: tomato;
    width: 2px;
  }

  &__cup-circle {
    position: absolute;
    top: -2px;
    left: 7px;
    height: 6px;
    background-color: #fc8a75;
    width: 6px;
    border-radius: 100%;
    z-index: 2;
  }

  &__cup-wrapper {
    width: 20px;
    min-height: 30px;
    position: absolute;
    animation: balance-cup 1s ease-in-out infinite;

    &._left {
      left: 30px;
      top: 0;
      animation: balance-cup-left 0.75s ease-in-out infinite;
    }

    &._right {
      right: 30px;
      top: 0;
      animation: balance-cup-right 0.75s ease-in-out infinite;
    }
  }

  &__cup {
    position: absolute;
    background-color: #fc8a75;
    height: 10px;
    width: 28px;
    border-radius: 0 0 10rem 10rem;
    bottom: 4px;
    left: -4px;
  }

  &__cup-chain {
    position: absolute;
    height: 20px;
    width: 2px;
    left: 9px;
    background-color: @color-persimmon;
    transform-origin: top;

    &._right {
      transform: rotate(-30deg);
    }

    &._left {
      transform: rotate(30deg);
    }
  }

  &__middle {
    position: relative;
    height: 100%;
    width: 7px;
    background-color: @color-persimmon;
    border-radius: 4px;

    &-top {
      position: absolute;
      left: 50%;
      top: -@size-x4;
      transform: translateX(-50%);
      width: 10px;
      height: 10px;
      border-radius: 100%;
      background-color: #fc8a75;
    }

    &-bar {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 50px solid transparent;
      border-right: 50px solid transparent;
      border-bottom: 10px solid #ff6f54;
      border-bottom-left-radius: 40px;
      border-bottom-right-radius: 40px;
      z-index: 1;
      top: -@size-x2;
      left: 50%;
      transform: translateX(-50%);
      transform-origin: center;
      animation: balance 0.75s ease-in-out infinite;
    }

    &-bottom {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      background-color: #ff6f54;
      height: @size-x4;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      width: 10px;
      bottom: @size-x6;
      z-index: 2;
    }

    &-base-bottom {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 30px solid transparent;
      border-right: 30px solid transparent;
      border-bottom: 15px solid #fc8a75;
      z-index: 1;
      bottom: @size-x3;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &__bottom {
    position: relative;
    z-index: 1;
    width: 100%;
  }

  &__bottom-first,
  &__bottom-second {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }

  &__bottom-first {
    max-width: 60px;
    border-radius: 10px;
    height: 7px;
    background-color: @color-persimmon;
    z-index: 2;
    bottom: 8px;
  }

  &__bottom-second {
    max-width: 50px;
    border-radius: 10px;
    height: 15px;
    background-color: #ff6f54;
    z-index: 1;
    bottom: 0;
  }

  &._mobile {
    transform: scale(0.5);
  }
}

@keyframes balance {
  0%,
  100% {
    transform: translateX(-50%) rotate(-12deg);
  }
  50% {
    transform: translateX(-50%) rotate(12deg);
  }
}

@keyframes balance-cup-left {
  0%,
  100% {
    transform: translateY(13px) rotate(3deg);
  }
  50% {
    transform: translateY(0) rotate(-3deg);
  }
}

@keyframes balance-cup-right {
  0%,
  100% {
    transform: translateY(0) rotate(3deg);
  }
  50% {
    transform: translateY(13px) rotate(-3deg);
  }
}
</style>
